import React, { Component } from 'react';
import { LevThreeSOne, LevThreeCardSTwo, LevThreeCardSThree } from './LevThreeSub';

export class LevThreeThree extends Component {
    render() {
        return (
            <div className="row level-three-three">
                <div className="col-md-8">
                    <LevThreeSOne tagName="" ServiceName="Financial <br /> Wealth Fund" BgColor="burgundy-bg" ButtonText="Subscribe" />
                </div>
                <div className="col-md-4">
                    <div className="row">
                        <div className="col-6 col-sm-6 col-md-12">
                            <LevThreeCardSTwo tagName="" BgColor="dark-blue-bg"
                                ServiceDesc="Our corporate values and beliefs are at the core of what we do, and these provide us with a framework of good conduct" />
                        </div>
                        <div className="col-6 col-sm-6 col-md-12">
                            <LevThreeCardSThree tagName="" BgColor="light-blue-bg"
                                ServiceDesc="The Bank recently launched ABCDEF, an initiatibe to tackle financial exclusion in the Nigeria" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export class LevThreeTwo extends Component {
    render() {
        return (
            <div className="row level-three-two">
                <div className="col-sm-6 col-md-8">
                    <LevThreeSOne tagName="services" ServiceName="Financial <br /> Wealth Fund" BgColor="burgundy-bg" ButtonText="Subscribe" />
                </div>
                <div className="col-sm-6 col-md-4">
                    <LevThreeCardSTwo tagName="OUR CULTURE" BgColor="dark-blue-bg"
                        ServiceDesc="Our corporate values and beliefs are at the core of what we do, and these provide us with a framework of good conduct" />
                </div>
            </div>
        );
    }
}

export class LevThreeFive extends Component {
    render() {
        return (
            <div className="row level-three-five">
                <div className="col-md-8">
                    <div className="row">
                        <div className="col-12 col-md-12">
                            <LevThreeSOne tagName="services" ServiceName="Financial <br /> Wealth Fund" BgColor="burgundy-bg" ButtonText="Subscribe" />
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-6 col-sm-6 col-md-6">
                                    <LevThreeCardSTwo tagName="OUR CULTURE" BgColor="dark-blue-bg"
                                        ServiceDesc="Our corporate values and beliefs are at the core of what we do, and these provide us with a framework of good conduct" />
                                </div>
                                <div className="col-6 col-sm-6 col-md-6">
                                    <LevThreeCardSThree tagName="investment" BgColor="light-blue-bg"
                                        ServiceDesc="The Bank recently launched ABCDEF, an initiatibe to tackle financial exclusion in the Nigeria" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="row">
                        <div className="col-6 col-sm-6 col-md-12">
                            <LevThreeCardSTwo tagName="OUR CULTURE" BgColor="dark-blue-bg"
                                ServiceDesc="Our corporate values and beliefs are at the core of what we do, and these provide us with a framework of good conduct" />
                        </div>
                        <div className="col-6 col-sm-6 col-md-12">
                            <LevThreeCardSThree tagName="investment" BgColor="light-blue-bg"
                                ServiceDesc="The Bank recently launched ABCDEF, an initiatibe to tackle financial exclusion in the Nigeria" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export class LevThreeSix extends Component {
    render() {
        return (
            <div className="row level-three-six">
                <div className="col-md-4">
                    <div className="row">
                        <div className="col-6 col-sm-6 col-md-12">
                            <LevThreeSOne tagName="services" ServiceName="Financial <br /> Wealth Fund" BgColor="burgundy-bg" ButtonText="Subscribe" />
                        </div>
                        <div className="col-6 col-sm-6 col-md-12">
                            <LevThreeCardSTwo tagName="OUR CULTURE" BgColor="dark-blue-bg"
                                ServiceDesc="Our corporate values and beliefs are at the core of what we do, and these provide us with a framework of good conduct" />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="row">
                        <div className="col-6 col-sm-6 col-md-12">
                            <LevThreeCardSTwo tagName="OUR CULTURE" BgColor="dark-blue-bg"
                                ServiceDesc="Our corporate values and beliefs are at the core of what we do, and these provide us with a framework of good conduct" />
                        </div>
                        <div className="col-6 col-sm-6 col-md-12">
                            <LevThreeCardSThree tagName="investment" BgColor="light-blue-bg"
                                ServiceDesc="The Bank recently launched ABCDEF, an initiatibe to tackle financial exclusion in the Nigeria" />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="row">
                        <div className="col-6 col-sm-6 col-md-12">
                            <LevThreeCardSTwo tagName="OUR CULTURE" BgColor="dark-blue-bg"
                                ServiceDesc="Our corporate values and beliefs are at the core of what we do, and these provide us with a framework of good conduct" />
                        </div>
                        <div className="col-6 col-sm-6 col-md-12">
                            <LevThreeCardSThree tagName="investment" BgColor="light-blue-bg"
                                ServiceDesc="The Bank recently launched ABCDEF, an initiatibe to tackle financial exclusion in the Nigeria" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}